import {IdName} from '@domain/id-name';
import {MatchingCriteria} from '@domain/utilities/tool/matching-criteria';
import {AssertionUtils} from '@vdw/angular-component-library';
import {ScheduleException} from './schedule-exception';
import {SchedulePattern} from './schedule-pattern';
import {ScheduleUnavailableDay} from './schedule-unavailable-day';

export class Schedule extends IdName {
  private _patterns: IdName[] | SchedulePattern[];
  private _unavailableDays: ScheduleUnavailableDay[];
  private _exceptions: ScheduleException[];
  private _matchingCriteria: MatchingCriteria[];

  public constructor(
    id: number,
    name: string,
    patterns: IdName[] | SchedulePattern[],
    unavailableDays: ScheduleUnavailableDay[],
    exceptions: ScheduleException[],
    matchingCriteria: MatchingCriteria[]
  ) {
    super(id, name);
    this._patterns = patterns;
    this._unavailableDays = unavailableDays;
    this._exceptions = exceptions;
    this._matchingCriteria = matchingCriteria;
  }

  public get patterns(): IdName[] | SchedulePattern[] {
    return this._patterns;
  }

  public set patterns(value: IdName[] | SchedulePattern[]) {
    this._patterns = value;
  }

  public get unavailableDays(): ScheduleUnavailableDay[] {
    return this._unavailableDays;
  }

  public get exceptions(): ScheduleException[] {
    return this._exceptions;
  }

  public get matchingCriteria(): MatchingCriteria[] {
    return this._matchingCriteria;
  }

  public static fromJSON(scheduleJSON: any): Schedule {
    return new Schedule(
      scheduleJSON.id,
      scheduleJSON.name,
      scheduleJSON.patterns.map((patternJSON: any) => ('pattern' in patternJSON ? SchedulePattern.fromJSON(patternJSON) : IdName.fromJSON(patternJSON))),
      scheduleJSON.unavailableDays?.map((unavailableDayJSON: any) => ScheduleUnavailableDay.fromJSON(unavailableDayJSON)),
      scheduleJSON.exceptions?.map((exceptionJSON: any) => ScheduleException.fromJSON(exceptionJSON)),
      scheduleJSON.resources?.map(
        (matchingCriteriaJSON: any) =>
          new MatchingCriteria(
            matchingCriteriaJSON.id,
            AssertionUtils.isNullOrUndefined(matchingCriteriaJSON.equipment) ? null : IdName.fromJSON(matchingCriteriaJSON.equipment),
            null,
            AssertionUtils.isNullOrUndefined(matchingCriteriaJSON.equipmentGroup) ? null : IdName.fromJSON(matchingCriteriaJSON.equipmentGroup),
            null
          )
      )
    );
  }

  public toJSON(): JSON {
    return {
      id: this._id,
      name: this._name,
      patterns: (this._patterns as SchedulePattern[]).map((pattern: SchedulePattern) => pattern.toJSON()),
      unavailableDays: this._unavailableDays.map((unavailableDay: ScheduleUnavailableDay) => unavailableDay.toJSON()),
      exceptions: this._exceptions.map((exception: ScheduleException) => exception.toJSON()),
      resources: this._matchingCriteria.map(
        (matchingCriteria: MatchingCriteria) =>
          ({
            id: AssertionUtils.isNullOrUndefined(matchingCriteria.id) ? undefined : matchingCriteria.id,
            equipmentId: matchingCriteria.machine?.id,
            equipmentGroupId: matchingCriteria.machineGroup?.id
          }) as any as JSON
      )
    } as any as JSON;
  }
}
